const sectors = [
  { name: "Logistics & supply chain", note: "Dispatch, fleet, warehouse and last-mile platforms." },
  { name: "Manufacturing",            note: "MES, quality control and shop-floor integration with ERP." },
  { name: "Financial services",       note: "Back-office automation, claims, settlement, reconciliation." },
  { name: "Retail & e-commerce",      note: "Order orchestration, custom checkout, omnichannel sync." },
  { name: "Public sector & utilities", note: "Citizen-facing portals, billing and case-management systems." },
  { name: "Healthcare",               note: "Clinical workflow tooling, patient communication, HL7/FHIR." },
  { name: "Telecommunications",       note: "OSS/BSS extension, provisioning, customer-facing self-service." },
  { name: "Energy & resources",       note: "SCADA-adjacent tooling, telemetry, regulatory reporting." },
  { name: "Education & research",     note: "LMS extension, assessment platforms, research data tooling." },
];

export default sectors;
